import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import MainNavigation from '../../components/ui/MainNavigation';
import Button from '../../components/ui/Button';
import ReviewList from './components/ReviewList';
import ReviewMetrics from './components/ReviewMetrics';
import ReviewResponseModal from './components/ReviewResponseModal';

const ProviderReviewManagement = () => {
  const { user, userProfile, loading } = useAuth();
  const navigate = useNavigate();
  const [filterStatus, setFilterStatus] = useState('all');
  const [selectedReview, setSelectedReview] = useState(null);
  const [showResponseModal, setShowResponseModal] = useState(false);

  useEffect(() => {
    if (!loading && (!user || !['provider', 'superadmin']?.includes(userProfile?.user_type))) {
      navigate('/leverancier-login');
    }
  }, [user, userProfile, loading, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Laden...</p>
        </div>
      </div>
    );
  }

  const handleRespond = (review) => {
    setSelectedReview(review);
    setShowResponseModal(true);
  };

  const handleModalClose = () => {
    setShowResponseModal(false);
    setSelectedReview(null);
  };

  const filterOptions = [
    { value: 'all', label: 'Alle Reviews' },
    { value: 'pending', label: 'Te Beantwoorden' },
    { value: 'responded', label: 'Beantwoord' },
    { value: 'featured', label: 'Uitgelicht' },
  ];

  return (
    <div className="min-h-screen bg-background">
      <MainNavigation />

      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
        {/* Header */}
        <div className="bg-card border-b border-border shadow-elevation-1 p-4 sm:p-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-heading font-bold text-foreground">Reviewbeheer</h1>
              <p className="text-sm text-muted-foreground mt-1">
                Beheer klantfeedback en bouw uw reputatie
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Metrics */}
          <ReviewMetrics />

          {/* Filters */}
          <div className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-center space-x-2">
              <span className="text-sm font-medium text-foreground">Filter:</span>
              {filterOptions?.map((option) => (
                <Button
                  key={option?.value}
                  variant={filterStatus === option?.value ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => setFilterStatus(option?.value)}
                >
                  {option?.label}
                </Button>
              ))}
            </div>
          </div>

          {/* Review List */}
          <ReviewList
            filterStatus={filterStatus}
            onRespond={handleRespond}
          />
        </div>
      </main>

      {/* Response Modal */}
      {showResponseModal && selectedReview && (
        <ReviewResponseModal
          review={selectedReview}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
};

export default ProviderReviewManagement;